module.exports = __webpack_public_path__ + "28b0e063775babb3fa2b5d30b49b2a98505d954453c77fd040c09bdf793070ac.png";